import { render } from "./AboutView.vue?vue&type=template&id=58a4520c&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=58a4520c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3459830904/src/personalwebsite2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a4520c"]])

export default __exports__